<div class="toaster" aria-live="polite" aria-atomic="false">
  @for (toast of toastService.toasts(); track toast.id) {
    <div class="toast" [class.toast--success]="toast.type === 'success'" [class.toast--error]="toast.type === 'error'">
      <span class="toast__message">{{ toast.message }}</span>
      <button
        type="button"
        class="toast__close"
        (click)="toastService.dismiss(toast.id)"
        aria-label="Fechar notificação"
      >
        ×
      </button>
    </div>
  }
</div>
